/**
 * Labstep
 *
 * @module components/User/Form/Signin
 * @desc Signin form
 */

import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { Message } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IUserFormSigninUsernameProps } from './types';

export const UserFormSigninUsername: React.FC<
  IUserFormSigninUsernameProps
> = ({ username, onClick }) => (
  <Message
    content={
      <div className={styles.message}>
        <div>{username}</div>
        <Icon name="times" onClick={onClick} />
      </div>
    }
  />
);
